
import axios from "axios";

import { IP } from "utils/Host";

// zmiana procesora w grupie z poziomu technologia stage
export function dropStageOpoznijZadanieOprawa(draggedId,dropDate,refreshGantAll) {

// id = procesor id
// console.log(" dropDate: "+dropDate)
  
  axios
  .get(IP + "API_0008_gant_procedura_opoznij_zadanie_oprawa/"+draggedId+"/"+dropDate+"/" + sessionStorage.getItem("token"))
    .then((res) => {
refreshGantAll()

    })


}


